import { ExprValue } from '../ExprValue';
import { validateArguments } from '../../SignatureValidation';
export var RunningCountFn;
(function (RunningCountFn) {
    RunningCountFn.Name = `RUNNING_COUNT`;
    RunningCountFn.Stage = "ANALYTIC";
    RunningCountFn.Signature = `RUNNING_COUNT(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: RunningCountFn.Name,
            stage: RunningCountFn.Stage,
            data: { type, role },
            init: () => {
                return { runningCount: null };
            },
            value: (context, ...argVals) => {
                const { state, frame: { index }, } = context;
                const values = argVals[0];
                const value = values[index];
                const runningCount = state.runningCount;
                if (value === null) {
                    return { value: runningCount, state };
                }
                if (typeof runningCount === 'number') {
                    const currentValue = ExprValue.add(runningCount, 1);
                    return {
                        value: currentValue,
                        state: { ...state, runningCount: currentValue },
                    };
                }
                else {
                    const currentValue = 1;
                    return {
                        value: currentValue,
                        state: { ...state, runningCount: currentValue },
                    };
                }
            },
        };
    }
    RunningCountFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: { name: RunningCountFn.Name, signature: RunningCountFn.Signature, location: callNode.location },
            arguments: [
                {
                    type: "NUMERIC",
                    stages: ["ANALYTIC", "AGGREGATE", "CONST"],
                },
            ],
        };
        return validateArguments(sig, args);
    }
    RunningCountFn.validate = validate;
})(RunningCountFn || (RunningCountFn = {}));
